import { IconPropsType } from '..';

export const SupportColoredIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.88264 13.7895L1.89688 15.8001C1.77035 15.8853 1.60001 15.7946 1.60001 15.6421V2.73684C1.60001 2.54142 1.67764 2.354 1.81582 2.21582C1.95401 2.07763 2.14143 2 2.33685 2H15.6C15.7954 2 15.9828 2.07763 16.121 2.21582C16.2592 2.354 16.3368 2.54142 16.3368 2.73684V13.0526C16.3368 13.2481 16.2592 13.4355 16.121 13.5737C15.9828 13.7118 15.7954 13.7895 15.6 13.7895H4.88264ZM4.37274 12.3158H14.8632V3.47368H3.07369V13.0526L4.37274 12.3158Z"
        fill="#E2E3E4"
      />
      <path
        d="M11 8.8V7.2C11 7.08954 11.0895 7 11.2 7H12.8C12.9105 7 13 7.08954 13 7.2V8.8C13 8.91046 12.9105 9 12.8 9H11.2C11.0895 9 11 8.91046 11 8.8Z"
        fill="currentColor"
      />
      <path
        d="M8 8.8V7.2C8 7.08954 8.08954 7 8.2 7H9.8C9.91046 7 10 7.08954 10 7.2V8.8C10 8.91046 9.91046 9 9.8 9H8.2C8.08954 9 8 8.91046 8 8.8Z"
        fill="currentColor"
      />
      <path
        d="M5 8.8V7.2C5 7.08954 5.08954 7 5.2 7H6.8C6.91046 7 7 7.08954 7 7.2V8.8C7 8.91046 6.91046 9 6.8 9H5.2C5.08954 9 5 8.91046 5 8.8Z"
        fill="currentColor"
      />
    </svg>
  );
};
